import {h, Component} from 'preact';
import {route} from "preact-router";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import PFeed from "../../../services/prematch-feed";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as P from "../mobile-templates/sports.jsx";
import * as I from "../utils/icons.jsx";

export default class MenuSearchEvent extends Component {
	state = {
		content: '',
		results: []
	};
	handler = null;
	
	setupEvents() {
		if (!!this.handler)
			return;
		window.document.addEventListener('click', this.handler = e => {
			if (!e.composedPath().includes(this.rootNode)) {
				this.closePopup();
			}
		})
	}
	closePopup() {
		this.setState({content: '', results: []});
		window.document.removeEventListener('click', this.handler);
		this.handler = null;
	}
	
    openEvent(event) {
        const [sportid, categoryid, tournamentid] = event.parent.split('/').slice(2);
        const eventid = event.id.split('/')[2];
        route('/prematch/'+ [sportid, categoryid, tournamentid, eventid].join('/'));
        this.setState({content: '', results: []});
    }

    performEventSearch(searchstring) {
        this.setState({content: searchstring});

        if (!!searchstring) {
            PFeed.searchEvent(searchstring, results => {
                if (!!results) {
                    this.setState({results: results.map(event => PFeed.getWithParents("/event/"+event.evento)).filter(({tournament}) => !!tournament)});
                    return;
                }

                this.setState({results: []});
            });
        } else {
            this.setState({results: []});
        }
    }

    localDateFormat(timestamp) {
        const d = new Date(timestamp * 1000);
        return d.toLocaleDateString(undefined, {month:'short', day: '2-digit'})
            +' '
            + d.toLocaleTimeString(undefined, {hour: '2-digit', minute: '2-digit', hourCycle: 'h23'});
    }

	render() {
		return <div>
			{/*<M.MenuTitle><Trans>Search Event</Trans></M.MenuTitle>*/}
			<M.SearchEventBodyContainer ref={ref => this.rootNode = ref && ref.base}>
				{false && <M.SearchDescContainer><Trans>Insert the events name or at least one team in the form below</Trans></M.SearchDescContainer>}
			  <M.SearchBarContainer>
				  <M.SearchInput>
					  <input 
						  class="h-full w-full bg-transparent text-inherit text-sm leading-none text-center px-2" 
						  placeholder="Search"
						  onInput={e => {this.setupEvents();this.performEventSearch(e.target.value)}}
						  value={this.state.content}
						  ref={ref => this.inputNode = ref} />
				    {!!this.state.content && <M.SearchContentWrapper parentRect={this.inputNode.getBoundingClientRect()}>
						<P.SearchPopupContainer>
							<P.SearchPopupHeader>
								<P.SearchPopupLabel><Trans>Search Results</Trans> ({this.state.results.length})</P.SearchPopupLabel>
								<P.SearchPopupClose onClick={e => this.closePopup()}><I.CloseIconSlim class="h-5" /></P.SearchPopupClose>
							</P.SearchPopupHeader>
							<M.SearchPopupEventsHolder>
								{this.state.results.map(({event, sport, category, tournament}) => (
									<P.SearchEventRow onClick={e => this.openEvent(event)}>
										<P.SearchEventName>{event.home} - {event.away}</P.SearchEventName>
										<P.SearchEventInfoRow>
											<P.SearchEventFlag><M.RegionFlagIcon category={category} /></P.SearchEventFlag>
											<P.SearchEventTournamentName>{sport.name} / {category.name} / {tournament.name}</P.SearchEventTournamentName>
											<P.SearchEventSeparator />
											<P.SearchEventSportFlag>
												<P.SportIconSmall sport={sport} />
											</P.SearchEventSportFlag>
										</P.SearchEventInfoRow>
									</P.SearchEventRow>
								))}
							</M.SearchPopupEventsHolder>
						</P.SearchPopupContainer>
					</M.SearchContentWrapper>}
				  </M.SearchInput>
			  </M.SearchBarContainer>
			</M.SearchEventBodyContainer>
		</div>
	}
}